import React from "react";
import { useTranslation } from "react-i18next";
import "./CMaboutleaders.css";

import topIcon from "../../Assets/identity.png"; 
import img1 from "../../Assets/CMAboutteam1.png";
import img2 from "../../Assets/CMAboutteam2.png";
import img3 from "../../Assets/CMAboutteam3.png";
import img4 from "../../Assets/CMAboutteam4.png";
import img5 from "../../Assets/CMAboutteam5.png";

const AboutLeaders = () => {
  const { t } = useTranslation();

  const leaders = [
    { img: img1, alt: t("about_leader_1_alt") },
    { img: img2, alt: t("about_leader_2_alt") },
    { img: img3, alt: t("about_leader_3_alt") },
    // { img: img4, alt: t("about_leader_4_alt") },
    { img: img5, alt: t("about_leader_5_alt") },
  ];

  return (
    <section className="cm-about-leaders-wrapper">
      <div className="cm-about-leaders-header">
        <img src={topIcon} alt={t("about_leaders_icon_alt")} className="cm-about-leaders-icon" />
        <h2 className="cm-about-leaders-title">
          {t("about_leaders_section_title")}
        </h2>
      </div>

      <div className="cm-about-leaders-row">
        {leaders.map((leader, index) => (
          <div className="cm-about-leaders-card" key={index}>
            <img src={leader.img} className="cm-about-leaders-img" alt={leader.alt} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default AboutLeaders;
